export default "__VITE_ASSET__Cty3TP60__"